import React from "react";
import Chart from "react-apexcharts";
import { Card } from "react-bootstrap";
import { GraphCardsHeader } from "@ui";

const RadialBarsChart = ({
  title,
  labels,
  series,
  graphColor,
  tooltip = "",
  showDownloadButtons = false,
  needCSVDownload = false,
}) => {
  const chartConfig = {
    series: series,
    options: {
      chart: {
        height: 250,
        width: 250,
        type: "radialBar",
      },
      plotOptions: {
        radialBar: {
          borderRadius: 0,
          hollow: {
            size: "60%",
          },
          track: {
            background: "#F2F2F2",
            strokeWidth: "100%",
            margin: 5,
          },
          dataLabels: {
            showOn: "always",
            name: {
              show: true,
              fontSize: "16px",
              fontWeight: "bold",
              offsetY: -10,
              color: "#008000",
            },
            value: {
              show: true,
              fontSize: "16px",
              fontWeight: "bold",
              offsetY: 10,
              color: "#333",
            },
          },
        },
      },
      states: {
        normal: {
          filter: {
            type: "none",
          },
        },
        hover: {
          filter: {
            type: "darken",
            value: 0.8,
          },
        },
      },
      colors: graphColor || [],
      legend: {
        show: true,
        position: "bottom",
        horizontalAlign: "center",
        markers: {
          width: 15,
          height: 15,
          radius: 15,
          offsetX: -5,
        },
        itemMargin: {
          horizontal: 15,
        },
        labels: {
          colors: "#000",
        },
        onItemClick: {
          toggleDataSeries: false,
        },
        formatter: function (label, { w }) {
          const index = w?.config?.labels?.indexOf(label) || 0;
          const value = w?.config?.series[index] || 0;
          return `${label} (${value}%)`;
        },
      },
      stroke: {
        lineCap: "butt",
      },
      labels: labels,
    },
  };

  function exportCSV() {
    if (!labels || !series || labels.length !== series.length) return;
    let csvContent = "Label,Value\n";
    labels.forEach((label, index) => {
      const value = series[index];
      csvContent += `${label},${value}\n`;
    });
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "data.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  return (
    <Card className="flex-grow-1">
      <GraphCardsHeader
        title={title}
        tooltip={tooltip}
        showDownloadButtons={showDownloadButtons}
        needCSVDownload={needCSVDownload}
        downloadCSV={exportCSV}
      />

      <Card.Body className="flex-grow-1">
        <Chart
          options={chartConfig.options}
          series={chartConfig.series}
          type="radialBar"
          height="300"
        />
      </Card.Body>
    </Card>
  );
};

export default RadialBarsChart;
